module.exports = __webpack_public_path__ + "static/media/Bay9.fc22b63a.JPG";